export * from "-!../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../node_modules/vue-loader/lib/index.js??vue-loader-options!./App.vue?vue&type=template&id=4b8b7b18"


//////////////////
// WEBPACK FOOTER
// ./src/App.vue?vue&type=template&id=4b8b7b18
// module id = /LNf
// module chunks = 7